<template>
  <component :is="layout">
    <router-view/>
  </component>
  
  <div v-if="$store.state.preloader" class="preloader"></div>
  <section class="notifications"></section>
</template>



<script>
import MainLayout  from '@/layouts/MainLayout'
import StartLayout from '@/layouts/StartLayout'



export default {
  components: {
    MainLayout, StartLayout
  },

  data() {
    return {

    }
  },



  mounted() {
    document.querySelector('body').setAttribute('data-dark-theme', localStorage.getItem('theme'))
  },



  computed: {
    layout() {
      return (this.$route.meta.layout || 'Main') + 'Layout'
    }
  }
}
</script>
